import { ApplicationState } from '@app/store'
import {
  actionCreators,
  IGlobalContactEmailAddressesState,
  selectContactEmailAddresses,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ContactEmailAddressSelector } from '../components/ContactEmailAddressSelector'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalContactEmailAddressesState>(
    {
      contactEmailAddresses: selectContactEmailAddresses(),
    },
  ),
  actionCreators,
)(ContactEmailAddressSelector)
